// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1YKuX","overflowing":"ReadFullNote_overflowing__3323U"};